import { mapAEMContentFragmentModelToShortName } from './constants';

export class AemHeadlessPropsService {
  static prettifyAemHeadlessResponse(container: dto.AEMContainer): common.AEMHeadlessProps {
    return Object.values(container[':items']).reduce((result, fragment: dto.AEMFragment) => (
      {
        ...result,
        [mapAEMContentFragmentModelToShortName.get(fragment.model)
          || fragment.model]: this.collectFragmentElements(fragment),
      }
    ), {} as common.AEMHeadlessProps);
  }

  static collectFragmentElements(fragment: dto.AEMFragment): { [key: string]: string } {
    const { elements } = fragment;
    return Object.keys(elements).reduce((res, key) => ({ ...res, [key]: elements[key].value }), {});
  }

  static transformResponse(response: dto.AEMContentRoot): common.AEMHeadlessProps {
    const { container } = response[':items'];
    return this.prettifyAemHeadlessResponse(container as any);
  }
}
